import {
  PhaseEntityType,
  converToEntityId,
} from 'components/organisms/projects/project-plan/phase-entity';
import { hoursPerWeekModifier } from 'components/organisms/templates/projects/resource-management/managers/hours-per-week-modifier';
import { floatUid } from 'utils/uid';
import { ProjectTemplateApi } from '../types';

export const generateNewTaskRows = (data) => {
  const phases = data.templateContent.projectPhases.map((phase, index) => {
    const task = {
      /**
       * floatUid at times returns same id when ran in loop,
       * hence adding index as patch fix to prevent duplicate ids.
       */
      taskId: floatUid() + index,
      isNew: true,
      projectPhase: {
        projectPhaseId: phase.projectPhaseId,
      },
      subTasks: [],
      startDay: phase.startDay || 1,
      duration: 1,
      private: phase.private,
    };

    return {
      ...phase,
      entityOrder: [
        ...(phase.entityOrder ?? []),
        converToEntityId(task.taskId, PhaseEntityType.Task),
      ],
      tasks: [...phase.tasks, task],
    };
  });

  return {
    ...data,
    templateContent: {
      ...data.templateContent,
      projectPhases: phases,
    },
  };
};

export const hoursPerWeekModifierRedux = (
  data: ProjectTemplateApi,
  isHoursPerWeek: boolean,
): ProjectTemplateApi => {
  if (!isHoursPerWeek) {
    return data;
  }

  const { allocations } = data.templateContent;
  const modifiedTemplateAllocations = hoursPerWeekModifier(allocations ?? []);

  return {
    ...data,
    templateContent: {
      ...data.templateContent,
      allocations: modifiedTemplateAllocations,
    },
  };
};
